<template>
    <div>
        <RemoteTable ref="table" :form="form" :table="table" v-show="id < 0">
            <template #default="{row, property}">
                <el-link type="primary" :underline="false" @click="id = row['id']" v-if="property === 'name'">
                    {{row['name']}}
                </el-link>
                <p v-else-if="property === 'type'">{{$utils.getEnumLabel('user.type', row['type'])}}</p>
                <p v-else-if="property === 'status'">{{$utils.getEnumLabel('status', row['status'])}}</p>
            </template>
            <template #tools="{row}">
                <el-tooltip content="删除" placement="top">
                    <el-button type="text" icon="el-icon-delete" size="small" @click="$refs.table.toDel(row)"></el-button>
                </el-tooltip>
            </template>
        </RemoteTable>
        <Config :id="id" @close="close" v-if="id > -1"></Config>
    </div>
</template>
<script>
    import RemoteTable from "@/components/RemoteTable"
    import Config from "./Config.vue"

    export default {
        components: {
            RemoteTable,
            Config,
        },
        data() {
            return {
                id: -1,
                form: {
                    tools: [
                        {icon: "el-icon-plus", click: () => {this.id = 0;}}
                    ],
                    configs: [
                        {label: "用户名", name: "name", type: "input", op: "contains", value: ""},
                        {label: "状态", name: "status", type: "select", options: this.$utils.getEnumOptions("status"), value: ""},
                        {label: "类型", name: "type", type: "select", options: this.$utils.getEnumOptions("user.type"), value: ""},
                    ]
                },
                table: {
                    urlPrefix: "/youzanApp",
                    columns: [
                        {label: "用户名", name: "name"},
                        {label: "clientId", name: "clientId"},
                        {label: "appId", name: "appId"},
                        {label: "sinoAppId", name: "sinoAppId"},
                        {label: "创建时间", name: "createTime", sortable: true},
                        {label: "操作", name: "tools", width: 100},
                    ],
                }
            }
        },
        methods: {
            close(reload) {
                this.id = -1;
                if (reload) {
                    this.$refs.table.load();
                }
            }
        }
    }
</script>